export enum PopoverPosition {
  AUTOMATIC = 'AUTOMATIC',
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
}
